import { ParseResult, parse } from 'papaparse';
import { ChangeEvent, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { onError } from '../toast/toast.slice';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import Button from 'common/components/buttons/button';

interface CSVReaderProps<T> {
  onCSVRead: (data: T[], fileName: string) => void;
}

const CSVReader = <T extends unknown>({ onCSVRead }: CSVReaderProps<T>) => {
  const dispatch = useDispatch();
  const hiddenFileInput = useRef(null);

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      parse<T, File>(file, {
        header: true,
        complete: (results: ParseResult<T>) => {
          const data = results.data;
          onCSVRead(data, file.name);
          event.target.value = '';
        },
        error: (error: Error, file: File) => {
          console.error('CSV parsing error:', error);
          dispatch(
            onError({
              title: 'A CSV Error Occurred',
              description:
                'An error occurred reading the CSV file. Please try again.'
            })
          );
        }
      });
    }
  };

  const handleClick = () => {
    (hiddenFileInput.current as any).click();
  };

  return (
    <div>
      <input
        type="file"
        accept=".csv"
        onChange={handleFileUpload}
        ref={hiddenFileInput}
        className="hidden"
      />
      <Button
        identifier="upload-file"
        theme={ButtonTheme.SECONDARY}
        onClick={handleClick}
      >
        <span>Upload File</span>
      </Button>
    </div>
  );
};

export default CSVReader;
